import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import trans from 'translate';
import './NavigationControls.scss';

const NavigationControls = ({ onNext, onPrev, nextTitle, backTitle, loading, laodingTitle, disabled }) => (
  <div className={clsx('nav-buttons-container', { 'd-grid-2-1': onNext && onPrev })}>
    {onPrev && (
      <button onClick={onPrev} type="button" className="button back">
        {trans(backTitle || 'button.back')}
      </button>
    )}
    {onNext && (
      <button onClick={onNext} type="button" disabled={loading || disabled} className="button green">
        {loading ? trans(laodingTitle) : trans(nextTitle || 'button.next')}
      </button>
    )}
  </div>
);

export default NavigationControls;

NavigationControls.defaultProps = {
  onNext: null,
  onPrev: null,
  nextTitle: '',
  backTitle: '',
  laodingTitle: '',
  loading: false,
  disabled: false,
};

NavigationControls.propTypes = {
  nextTitle: PropTypes.string,
  backTitle: PropTypes.string,
  laodingTitle: PropTypes.string,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};
